<template>
    <div class="asdan-background">
        <common-header ref="header"></common-header>

        <el-row type="flex" class="main" justify="center" id="main">
            <el-col :span="22" class="main-content mt-20 mb-20 p-20">
                <template>
                    <el-tabs style="width: 100%" v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane :key="item.name" :label="item.title" :name="item.name" v-for="(item, index) in tabLabel">
                            <!--上方操作框-->
                            <el-row type="flex" class="row-bg p-10 mt-10 bg-lightgarg" justify="space-between">
                                <el-col :span="5">
                                    <el-select v-if="item.role ==='teacher' || item.role === 'ta'" v-model="selectStu" clearable filterable  placeholder="Please Select Student" v-loading="loading" element-loading-text="loading..." no-match-text="No data" no-data-text="No data" @change="selectStuNoti">
                                        <el-option v-for="stu in stuOptions" :key="stu.id" :label="stu.displayName+' - '+stu.givenName+ ' ' +stu.familyName" :value="stu.id"></el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="19" class="text-right">
                                    <el-button v-if="item.role ==='teacher'" round style=" background: #eef1f6;" :disabled="item.isAllRead || isStuReadDisabled"  @click="whetherMarkStudent" :loading="studentReadLoading">
                                        Student Read
                                    </el-button>
                                    <el-button round style="background: #eef1f6;" :disabled="item.isAllRead"  @click="whetherMarkAll" :loading="allReadLoading">
                                        All Read
                                    </el-button>
                                </el-col>
                            </el-row>

                            <!--下方表格-->
                            <el-table v-loading="tableLoading" element-loading-text="loading..." :data="tableData" :default-sort = "{prop: 'date', order: this.order}"  @sort-change="sortList" empty-text="No data" style="width: 100%" class="mb-50 table-pointer td-padding-small">
                                <el-table-column label="Sender" width="190">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.fromName + ' - ' + scope.row.fromGivenName + ' ' + scope.row.fromFamilyName}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column sortable prop="time" label="Date" width="170"></el-table-column>
                                <el-table-column  label="Information" min-width="400">
                                    <template slot-scope="scope" >
                                            <span class="toDialog" @click="toDialog(scope.row)">
                                            <b>{{scope.row.typeName}}</b>
                                                {{scope.row.page }} <span>{{scope.row.templateHtml}}</span> of
                                                <span>{{scope.row.category ==='epq'?'EPQ':'LOG'}}</span> -
                                                <b>[ {{scope.row.skill }} ]</b>
                                                <span class="dark">{{scope.row.type ==='comment'?': '+scope.row.comment:''}}</span>
                                            </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Actions" width="90" align="center">
                                    <template slot-scope="scope">
                                        <el-button type="text" :disabled="scope.row.read === true" @click="setCurrentLine(scope.row)">
                                            <i class="el-icon-check" style="font-size: 22px; font-weight: bold;"></i>
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <!--分页符-->
                            <div class="text-center mt-20 mb-50">
                                <el-pagination layout="prev, pager, next" :page-size="size" :current-page="currentPage" :page-count="totalPages"
                                               @current-change="changeCurrentPage">
                                </el-pagination>
                            </div>
                        </el-tab-pane>

                    </el-tabs>
                </template>
            </el-col>
        </el-row>
        <skill-dialog ref="reportDialog" v-on:close="setCurrentLine" :isLineRead="this.isLineRead" :notificationId = 'this.notificationId'></skill-dialog>
        <evidence-dialog ref="evidenceDialog" :userId="notificationUserId" v-on:close="setCurrentLine" :isLineRead="this.isLineRead" :notificationId = 'this.notificationId'></evidence-dialog>

    </div>
</template>

<script>
    import Header from './common/Header.vue'
    import Cookies from 'js-cookie'
    import SkillDialog from './common/ReportDialog.vue'
    import EvidenceDialog from './common/EvidenceDialog.vue'

    export default {
        components: {
            SkillDialog,
            'common-header': Header,
            'skill-dialog': SkillDialog,
            'evidence-dialog': EvidenceDialog
        },
        data(){
            return{
                screenHeight: document.body.clientHeight - 60 - 40,//减去header的60px
                activeName: '1',//tab默认值为'未读'
                isNextPage:false,//判断是否点击了第二个tab
                tabLabel: [],
                loading: true,
                role:'',//cookie读取
                teacherId:0,//cookie读取
                userid:0,//cookie读取

                selectStu:'',
                selectStuUserId:0,
                stuOptions:[],
                //列表分页
                order:'',
                isLineRead:false,//弹窗关闭时通过此来判断是否还需标为已读
                notificationId:0,//弹窗关闭时将此条标为已读
                tableLoading:false,
                unReadTableData:[],
                tableData: [],
                currentPage:1,
                totalPages:1,
                size:15,
                queryStudentId:0,//从progress跳转过来的学生id

                report:{},
                notificationUserId:0,

                // 控制mark all as Read按钮 loading状态
                allReadLoading: false,
                studentReadLoading: false,
                isStuReadDisabled:true
            }
        },
        mounted () {
            this.$nextTick(() => {
                this.init();
                this.getNotification();
                this.getProfile();
                this.getUnreadNotification();
                if(this.role ==='teacher' || this.role === 'ta'){
                    this.getUsers();
                }
                document.getElementById('main').style.minHeight = this.screenHeight + "px";//页面初始化设置最小高度
            })

        },
        methods:{
            sortList(sort){
                this.order = sort.order;
                this.currentPage = 1;
                this.getNotification(this.order)
            },
            init () {
                this.teacherId = Cookies.get('teacherId');
                this.studentId = Cookies.get('studentId');
                this.userid = Cookies.get('userid');
                this.role = Cookies.get('role');
                this.tabLabel.push({//tab状态
                    title: 'Unread',
                    name: '1',
                    role:this.role,
                    isAllRead:false

                }, {
                    title: 'All',
                    name: '2',
                    role:this.role,
                    isAllRead:false
                })
                let query = this.$route.query
                if (query) {
                    this.queryStudentId = query.studentId;
                    this.selectStu = query.studentName

                } else {
                    this.$message.error('Cannot get notification')
                }
            },

            //获取学生列表
            getUsers(){
                if(this.role ==='teacher' || this.role === 'ta'){
                    this.loading = false;
                    this.$http.get('notification/student',{
                        params:{
                            teacherId:this.teacherId,
                            all:this.isNextPage,//all为true返回全部列表，false返回未读列表
                        }
                    }).then(response => {
                        //渲染数据
                        this.stuOptions = response;
                    }).catch(error => {
                        this.$message.error(error.message)
                    })
                }
            },

            //获取notification
            getNotification(order){
                this.tableLoading = true;
                this.$http.get('notification',{
                    params:{
                        role:this.role,
                        id:(this.role ==='student'?this.studentId:this.teacherId),
                        size:this.size,
                        //从progress跳转过来时this.selectStu即select值为字符串，则从query直接取id
                        studentId:(typeof this.selectStu) !=='number' && this.selectStu !=='' ?this.queryStudentId:this.selectStu,
                        read:this.isNextPage,//isNextPage为true表示查看下一tab全部列表，false返回未读列表
                        page:(this.currentPage-1),
                        //element order有三种结果 ：'descending'，'ascending'，null，初始化时undefinded，默认情况sort设为true，否则按order 来
                        sort:order === undefined || order === '' || order === 'descending'
//                        sort:(order !=='descending'||'ascending'?true:(order === 'descending'))
                    }
                }).then(response => {
                    //渲染数据
                    this.tableData = response.list;
                    this.studentReadLoading =true;
                    this.isStuReadDisabled =true;
//                    var templateText = ['Witness testimony', 'Peer/Witness statement', 'Team action plan', 'Personal action plan', 'Action plan', 'PDF', 'Photographic', 'Team Video'];
                    var templateText = ['PDF','Photographic','Team Video','Peer/Witness statement','Observation checklist','Observation checklist','Observation checklist'];
                    for(var i=0; i<this.tableData.length; i++){
                        if(this.tableData[i].type ==='comment'){
                            this.$set(this.tableData[i],'typeName', 'Commented')
                        }else if(this.tableData[i].type ==='pageEvidence'){
                            this.$set(this.tableData[i],'typeName', 'Edited evidence')
                        }else {
                            this.$set(this.tableData[i],'typeName', 'Edited')
                        }
                        if(this.tableData[i].templateType !== null){
                            this.tableData[i].templateHtml = templateText[this.tableData[i].templateType];
                        }
                    }

                    let _this = this;
                    if(this.selectStu > 0){
                        response.list.forEach(function (pro) {
                            if(pro.read == false){
                                _this.isStuReadDisabled = false//如果该学生搜出来的通知一旦有未读的， 则student read按钮可用
                                return false
                            }
                        })
                    }

                    this.totalPages = response.totalPages;
                    this.tableLoading = false;
                    // 控制mark all as Read按钮loading
                    this.allReadLoading = false;
                    this.studentReadLoading = false;
                }).catch(error => {
                    this.$message.error(error.message)
                    this.tableLoading = false;
                    this.allReadLoading = false;
                    this.studentReadLoading = false;
                })
            },

            //获取未读notification总数
            getUnreadNotification(order){
                this.tableLoading = true;
                this.$http.get('notification',{
                    params:{
                        role:this.role,
                        id:(this.role ==='student'?this.studentId:this.teacherId),
                        size:this.size,
                        //isNextPage为true表示查看下一tab全部列表，false返回未读列表
                        studentId:(typeof this.selectStu) !=='number' && this.selectStu !=='' ?this.queryStudentId:this.selectStu,
                        read:false,
                        page:(this.currentPage-1),
                        sort:true,
                    }
                }).then(response => {
                    //渲染数据
                    this.unReadTableData = response.list;
                    if(this.unReadTableData.length === 0){
                        var _this = this;
                        _this.tabLabel.forEach(function(val, index){
                            _this.$set(_this.tabLabel[index],'isAllRead', true)
                        })

                    }
                    this.tableLoading = false;
                    // 控制mark all as Read按钮loading
                    this.allReadLoading = false;
                }).catch(error => {
                    this.$message.error(error.message);
                    this.tableLoading = false;
                    this.allReadLoading = false;
                })
            },

            //改变当前页函数
            changeCurrentPage(val){
                this.currentPage = val;
                this.getNotification(this.order);
            },

            //搜索某学生
            selectStuNoti(ev){
                this.currentPage = 1;
                this.selectStu = ev;
                let _this = this
                if(ev !==''){
                    _this.stuOptions.forEach(function (pro) {
                        if(pro.id === ev){
                            _this.selectStuUserId  = pro.userId
                        }
                    })
                }
                this.getNotification();
            },

            //TAB切换
            handleClick(tab, event) {
                if(tab.index == 0){
                    this.isNextPage = false;
                }else {
                    this.isNextPage = true;
                }
                this.currentPage = 1;
                this.selectStu='';
                this.isStuReadDisabled = true;
                this.getUsers();
                this.getNotification();
            },

            //点击按钮标记改行为已读
            setCurrentLine(row){
                this.tableLoading = true;
                this.$http.patch('notification/read/'+row.id).then(response => {
                    //渲染数据
                    this.getNotification(this.order);
                    this.getUnreadNotification();
                    // 点击按钮后更新通知数量
                    this.$refs.header.getNotificationCount();
                    this.tableLoading = false;
                    this.isLineRead = false;//初始关闭弹窗后是否标记已读的判断条件
                    this.notificationId = 0;//初始关闭弹窗后标记的行
                }).catch(error => {
                    this.$message.error(error.message);
                    this.tableLoading = false;
                })
            },

            //标记所有
            markAll(){
                this.allReadLoading = true;
                this.tableLoading = true;
                this.$http.patch('notification/readAll/'+this.userid).then(response => {
                    //渲染数据
                    this.getNotification();
                    this.getUnreadNotification();
                    // 点击按钮后更新通知数量
                    this.$refs.header.getNotificationCount();
                }).catch(error => {
                    this.$message.error(error.message);
                    this.allReadLoading = false;
                    this.tableLoading = false;
                })
            },

            //标记当前学生
            markThisStudent(){
                this.studentReadLoading = true;
                this.tableLoading = true;
                this.$http.patch('notification/readByStudent/'+this.selectStuUserId).then(response => {
                    //渲染数据
                    this.getUsers();
                    this.selectStu='';
                    this.isStuReadDisabled=true;
                    this.getNotification();
                    this.getUnreadNotification();
                    // 点击按钮后更新通知数量
                    this.$refs.header.getNotificationCount();
                }).catch(error => {
                    this.$message.error(error.message);
                    this.studentReadLoading = false;
                    this.tableLoading = false;
                })
            },

            whetherMarkAll() {
                this.$confirm('This will mark all unread messages as read.', 'Confirm', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.markAll();
                }).catch(() => {//弹窗点击cancel后执行的方法

                });
            },

            whetherMarkStudent() {
                this.$confirm('This will mark the unread messages of the current selected student as read. ', 'Confirm', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.markThisStudent();
                }).catch(() => {//弹窗点击cancel后执行的方法

                });
            },

          //学生端获取学生个人信息（拼音）
          getProfile(){
            if(this.role ==='student'){
              this.$http.get('student/' + this.studentId).then(response => {
                this.displayName = response.displayName + ' - ' + response.givenName + '  ' +  response.familyName;
              }).catch(error => {
                this.$message.error(error.message)
              })
            }
          },

          toDialog (notification) {
              console.log('todailog')
                this.report.id = notification.reportId;
                this.notificationUserId = notification.fromUserId;
                if(notification.questionId !== null){
                    this.$http.get('question/skill/'+notification.questionId).then(response => {
                        let skill = response;
                        let page ;
                        let studentId = this.role === 'student'?this.studentId:notification.fromStudentId;
                        let studentName = this.role === 'student'? this.displayName : (notification.fromName + ' - ' + notification.fromGivenName + ' ' + notification.fromFamilyName );
                        for(let i=0;i<skill.pageList.length;i++){
                            if(skill.pageList[i].confirmed) page = skill.pageList[i];
                        }
                        this.$refs.reportDialog.showDialogFromNoti(this.report, skill, page,
                            {
                                commentId:notification.commentId,
                                type:notification.type,
                                studentId:studentId,
                                studentName: studentName,
                                questionId:notification.questionId
                            })

                    }).catch(error => {
                        this.$message.error(error.message);
                    });
                }
                if(notification.pageEvidenceId !== null){
                    this.$refs.evidenceDialog.showEvidenceDialog(notification.templateType, notification.pageEvidenceId,
                        {
                            commentId:notification.commentId,
                            type:notification.type,
                            questionId:notification.pageEvidenceQuestionId
                        }
                    );
                }
                this.notificationId = notification.id;
                this.isLineRead = notification.read

            }




        },
    }
</script>

<style lang="scss" scope>

    @import "../css/variable";
    .bg-coclor{
        background: #edf7ff;
    }
    .table-pointer thead {
        cursor: pointer;
    }
    .td-padding-small td {
        padding: 0;
    }
    .toDialog:hover{
        color: $success!important;
        text-decoration: underline;
        cursor: pointer;
    }
    .toDialog:hover .dark{
        color: $success!important;
    }
</style>


// WEBPACK FOOTER //
// Notification.vue?d82e21fc